export default {
    getURL({ template, original, width, height, playButtonOverlayColor }) {
        // This is a bad hack. We should support this from server side, but it would
        // blow this up right now too much. YOLO.
        let heightText = `${height}`;
        switch (playButtonOverlayColor) {
            case 'blue':
                heightText += '/l_play-blue/fl_relative,w_0.28/fl_layer_apply';
                break;
            case 'redSmall':
                heightText += '/l_play-red/fl_relative,w_0.15/fl_layer_apply';
                break;
            default:
                break;
        }

        if (original) {
            return template.replace(',w_---WIDTH---,h_---HEIGHT---', '');
        } else {
            return template.replace('---WIDTH---', width).replace('---HEIGHT---', heightText);
        }
    },
    getRgbColorFromHex(hex) {
        hex = hex.slice(1);
        const value = parseInt(hex, 16);
        const r = (value >> 16) & 255;
        const g = (value >> 8) & 255;
        const b = value & 255;

        return [r, g, b];
    },
    getContrast(foreground, background) {
        const foregroundLuminance = this.luminance(foreground);
        const backgroundLuminance = this.luminance(background);

        const brightest = Math.max(foregroundLuminance, backgroundLuminance);
        const darkest = Math.min(foregroundLuminance, backgroundLuminance);

        return (brightest + 0.05) / (darkest + 0.05);
    },
    luminance(rgb) {
        const [r, g, b] = rgb.map((v) => {
            v /= 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        return r * 0.2126 + g * 0.7152 + b * 0.0722;
    },
};
